import { useEffect, createContext, useState, useContext } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { auth } from '../firebase'; 
import { 
  onAuthStateChanged, 
  signInWithEmailAndPassword, 
  signOut as firebaseSignOut 
} from 'firebase/auth';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [currentUser, setCurrentUser] = useState(null);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true); 

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setCurrentUser(user);
      setIsAuthenticated(!!user); 
      setLoading(false); 
      console.log("Auth State Changed, User:", user ? user.email : null, "IsAuth:", !!user);
    });
    return unsubscribe;
  }, []);

  const login = async (email, password) => {
    try {
      await signInWithEmailAndPassword(auth, email, password);
      console.log("Login successful for:", email);
      return true; 
    } catch (error) {
      console.error("Firebase Login Error:", error.message);
      throw error; 
    }
  };

  const logout = async () => {
    try {
      await firebaseSignOut(auth);
      console.log("Logout successful");
    } catch (error) {
      console.error("Firebase Logout Error:", error.message);
    }
  };

  const value = {
    currentUser,
    isAuthenticated,
    login,
    logout,
    loading 
  };

  if (loading) {
    return <div className="min-h-screen flex items-center justify-center">인증 상태 확인 중...</div>; 
  }

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);

export const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return <div className="min-h-screen flex items-center justify-center">인증 상태 확인 중...</div>; 
  }

  if (!isAuthenticated) {
    return <Navigate to="/jy-dev/login" state={{ from: location }} replace />;
  }

  return children; 
};
